import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NotificationDialogService {
  btnClicked: BehaviorSubject<boolean> = new BehaviorSubject(false);
  btnClicked$ = this.btnClicked.asObservable();
}
